import ResetEmail from 'components/account/resetEmail';
import ResetPassword from 'components/account/resetPassword';
import { getSharedPageProps, SharedPageProps } from 'components/Layout';
import { GetServerSideProps } from 'next';
import FinishSignUp from 'pages/login/finishsignup';
import { ParsedUrlQuery } from 'querystring';
type AccountAction = {
  mode: string;
  oobCode: string;
  sharedPageProps: SharedPageProps;
};

export default function AccountAction(props: AccountAction): JSX.Element {
  if (props.mode === 'resetPassword') {
    return <ResetPassword token={props.oobCode} />;
  }
  if (props.mode === 'recoverEmail') {
    return <ResetEmail token={props.oobCode} />;
  }
  if (props.mode === 'signIn') {
    return <FinishSignUp token={props.oobCode} />;
  }
}

export const getServerSideProps: GetServerSideProps = async ({
  query,
}: {
  query: ParsedUrlQuery;
}) => {
  const sharedPageProps = await getSharedPageProps();

  return {
    props: { ...query, ...sharedPageProps } as AccountAction,
  };
};
